// api.ts - Add to your existing API structure

import { ApiEndpoints } from "@shared/api/api-endpoints";
import { onboardingApiClient } from "@shared/api/clients/apiClientFactory";
import {
  CriticalParametersResponse,
  UpdateCriticalParameterRequest,
  DeleteCriticalParameterRequest,
  CriticalParameterAPI,
  CriticalParameter,
  CreateCriticalParameterRequest,
} from "./types";

export const criticalParametersApi = {
  // Get all critical parameters
  getCriticalParameters: async (
    utilityId: string,
    searchQuery?: string
  ): Promise<CriticalParametersResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      searchQuery ? "search/onboarding_config" : "config-map/criticality",
      (query) => {
        query.push("remote_utility_id", utilityId.toString());
        if (!searchQuery && !searchQuery.trim()) {
          query.push("show_inactive", "true");
        }

        // Add search parameter if provided
        if (searchQuery && searchQuery.trim()) {
          query.push("search_field", "criticality");
          query.push("search_data", searchQuery.trim());
        }
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },

  // Create new critical parameter
  createCriticalParameter: async (
    data: CreateCriticalParameterRequest
  ): Promise<{ result: string }> => {
    const url = ApiEndpoints.createUrl("onboarding", "config-map/criticality");
    const response = await onboardingApiClient.post(url, data);
    return response.data;
  },

  // Update critical parameter
  updateCriticalParameter: async (
    data: UpdateCriticalParameterRequest
  ): Promise<{ result: string }> => {
    const url = ApiEndpoints.createUrl("onboarding", "config-map/criticality");
    const response = await onboardingApiClient.patch(url, data);
    return response.data;
  },

  // Delete critical parameter
  deleteCriticalParameter: async (
    data: DeleteCriticalParameterRequest
  ): Promise<{ result: string }> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/criticality",
      (query) => {
        query.push("remote_utility_id", data.remoteUtilityId);
        query.push("code", data.code);
      }
    );
    const response = await onboardingApiClient.delete(url);
    return response.data;
  },
};

// Transform function to convert API response to component format
export const transformCriticalParameter = (
  apiParam: CriticalParameterAPI
): CriticalParameter => {
  return {
    id: apiParam.code,
    name: apiParam.name,
    description: apiParam.description || `NA`, // API doesn't provide description
    weightScore: apiParam.score,
    weightage: apiParam.weightage,
    isActive: apiParam.isActive,
    createdBy: apiParam.createdBy,
    createdDate: apiParam.createdDate,
    code: apiParam.code,
  };
};
